import React from 'react';

import RichText from 'core/components/RichText';
import Collapse from 'core/components/Collapse';
import HelpText from 'pods/forms/components/base/HelpText';
import Label from 'pods/forms/components/base/Label';
import { Icon, ICONS } from 'core/components/Icon';
import { JssTextType } from 'core/utils/sitecore-utils';

import * as S from './CtrlHolder.style';

export interface IProps {
	htmlId?: string;
	label?: string;
	helpText?: string | React.ReactNode;
	errorMsg?: string;
	tooltip?: React.ReactNode;
	required?: boolean;
	readonly?: boolean;
	appendMsg?: string;
	optionalText?: string;
	bottomMsg?: JssTextType;
	value?: any;
	hasErrorIcon?: boolean;
	/** Remove top and bottom margin */
	noMargin?: boolean;
	children: React.ReactNode;
}

const CtrlHolder = ({
	htmlId,
	label,
	helpText,
	errorMsg,
	tooltip,
	required = false,
	readonly = false,
	noMargin = false,
	appendMsg,
	value,
	children,
	optionalText,
	bottomMsg,
	hasErrorIcon = false,
}: IProps) => {
	const hasError = !!errorMsg;
	const hasValue = !!value;

	const labelProps = {
		htmlId,
		label,
		hasError,
		required,
		readonly,
		tooltip,
		optionalText,
	};

	return (
		<S.CtrlHolder {...{ hasError, hasValue, noMargin }}>
			{label && (
				<S.LabelContents>
					<Label {...labelProps} />
					{!!helpText && (
						<HelpText id={`${htmlId}-helpText`}>{helpText}</HelpText>
					)}
				</S.LabelContents>
			)}

			<S.FieldContents>
				<S.Field hasAppendMsg={!!appendMsg}>{children}</S.Field>
				{!!appendMsg && <RichText content={appendMsg} />}

				{htmlId && (
					<Collapse isOpen={hasError}>
						<S.ErrorMessage id={`${htmlId}-error`} role="alert">
							{hasErrorIcon && <Icon name={ICONS.ERROR} />}
							{errorMsg && <RichText content={errorMsg} />}
						</S.ErrorMessage>
					</Collapse>
				)}
			</S.FieldContents>
			{!!bottomMsg && (
				<S.BottomMessage>
					<RichText content={bottomMsg.value} />
				</S.BottomMessage>
			)}
		</S.CtrlHolder>
	);
};

export default CtrlHolder;
